
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { Customer } from '../../interface/customer/customer';
import { ledgerDate } from '../../interface/ledger/ledger';
import { HttpService } from '../http/http.service';
import { toDateParam } from 'src/app/utils';

@Injectable({
  providedIn: "root",
})
export class CustomerService {
  // getAll() {
  //   throw new Error('Method not implemented.');
  // }

  constructor(private _httpService: HttpService) {}
  getAllCustomer(): Promise<any> {
    return firstValueFrom(this._httpService.get("/Customers?size=-1"));
  }
  getAllCustomerPaginated(params?: { townId?: number; routeId?: number,search?: string }): Promise<any> {
    let url = `/Customers/Paginated?`;
    if(params.search?.trim().length>0)url +=`Query=${params.search}`
    if(params.townId)url +=`&TownId=${params.townId}`
    if(params.routeId)url +=`&RouteId=${params.routeId}`

    return firstValueFrom(this._httpService.get(url));
  }
  get(id: number): Promise<Customer> {
    return firstValueFrom(this._httpService.get("/Customers/" + id));
  }
  sendCustomerData(data: Customer) {
    return this._httpService.post("/Customers", data);
  }
  updateCustomerData(id: number, data: Customer): Promise<void> {
    return firstValueFrom(this._httpService.patch("/Customers/", id, data));
  }
  public async delete(id: number): Promise<void> {
    return firstValueFrom(this._httpService.delete("/Customers/", id));
  }
  public async getledger(id: number, data: ledgerDate): Promise<any> {
    return firstValueFrom(
      this._httpService.get(
        `/Customers/${id}/ledger?startDate=${toDateParam(data.startDate)}&endDate=${toDateParam(data.endDate)}`
      )
    );
  }
  getinvoice(id: number, data: ledgerDate) {
    if (data.startDate == null && data.endDate == null) {
      return this._httpService.get("/Customers/" + id + "/invoices");
    } else {
      return this._httpService.get(
        `/Customers/${id}/invoices?startDate=${toDateParam(data.startDate)}&endDate=${toDateParam(data.endDate)}`
      );
    }
  }

  getArrears(id: number): Promise<any> {
    return firstValueFrom(
      this._httpService.get("/SaleInvoices/Payments/" + id)
    );
  }

  getArrearsPdf(params?: { townId?: number; routeId?: number; townName?: string; routeName?: string }): Promise<Blob> {
    const query = new URLSearchParams();
    if (params?.townId) query.set('townId', String(params.townId));
    if (params?.routeId) query.set('routeId', String(params.routeId));
    if (params?.townName) query.set('townName', params.townName);
    if (params?.routeName) query.set('routeName', params.routeName);
    return firstValueFrom(this._httpService.getBlob(`/Customers/arrears/pdf?${query}`));
  }
}
